import React from 'react';
import styled from 'styled-components';
import { CONSTS } from '../elements/_constants';
type FooterProps = {
    className?: string
}
const FooterComponent = (props: FooterProps) => {
    return (
        <div className={props.className}>
            <div>
                تمامی حقوق برای طراح و توسعه‌دهنده محفوظ می‌باشد.
            </div>
            <div>
                توسعه توسط <a target="_blank" href="http://maivan.dev">مایوان</a> - ۱۳۹۸
            </div>
        </div>
    )
}
const Footer = styled(FooterComponent)`
    margin-top: auto;
    width: calc(100% - 29px);
    margin-left: auto;
    margin-top: 29px;
    border-top: 1px solid #DFE3E8;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 18px;
    padding-bottom: 18px;
    padding-right: 10px;
    padding-left: 10px;
    box-sizing: border-box;
    font-family: ${CONSTS.fonts.primary.regular};
    font-size: 14px;
    color: #616161;
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
        flex-direction: column;
        width: calc(100% - 15px);
        margin-bottom: 50px;
    }
    @media only print{
        display: none;
    }
`
export default Footer;